/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type RoutingProfileEnum = (typeof RoutingProfileEnum)[keyof typeof RoutingProfileEnum];

export const RoutingProfileEnum = {
  DRIVING_TRAFFIC: 'DRIVING_TRAFFIC',
  WALKING: 'WALKING',
  CYCLING: 'CYCLING',
} as const;
